<template>

  <div>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth" :status="status"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="productSupplyId" :primary-key="form.productSupplyId"
                 :foreign-key-column="foreignKeyColumn" :foreign-key="foreignKey"
                 @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDeleteDefault">

      <t-input v-model="form.productSupplyId" hidden/>

      <b-col cols="12" class="mb-2">

        <t-input v-model="form.typeSupply" label="Tipo de Insumo" hide-label :options="typeSupplyOptions" radio
                 required/>

        <b-row>

          <b-col xl="9">

            <b-row>

              <t-input cols="6" v-if="form.typeSupply === 1" @change="setMeasure" v-model="form.rawMaterialId"
                       label="Matéria-Prima"
                       :options="rawMaterialOptions" required select/>

              <t-input cols="6" v-if="form.typeSupply === 2" @change="setMeasure" v-model="form.componentId"
                       label="Componente"
                       :options="componentOptions" required select/>


              <t-input cols="3" v-model="form.quantity" submitted number :decimals="measure.decimalPrecision" label="Quantidade" required>
                <template #input-group-prepend>{{ measure.unit }}</template>
              </t-input>

              <t-input cols="3" v-model="form.note" label="Observação"/>

            </b-row>

          </b-col>

          <b-col xl="3" class="button-form-inline">

            <t-button :sending="status === 'sending'" :text="onButtonSubmitText(command)" no-icon submit/>

            <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
              {{ t('go-back') }}
            </b-link>

          </b-col>

        </b-row>

      </b-col>

    </t-form-list>

  </div>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import ui from "@/assets/scripts/ui";
import http from "@/services/config/http-common";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList},
  name: 'ProductSupply',
  data() {
    return {
      path: "product/item-supply", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "productId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "productSupplyId", keyDelete: "productSupplyId"},
        {key: "name", label: "Insumo", cols: "5"},
        {key: "typeSupply", label: "Tipo de Insumo", cols: "2"},
        {key: "quantity", label: "Quantidade", cols: "2", align:"right"},
        {key: "note", label: "Observação", cols: "2", align: "right"},
      ],
      form: {
        productId: this.foreignKey,
        productSupplyId: 0,
        typeSupply: 1,
        quantity: 0,
        rawMaterialId: 0,
        componentId: 0,
        note: "",
        status: 1,

      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        codeGeneratorPrefix: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
        "typeSupply",
      ],
      //--------------------------------------------------------------------------------------
      rawMaterialList: [],
      componentList: [],
      rawMaterialOptions: [],
      componentOptions: [],
      measure: {
        unit: "Kg",
        decimalPrecision: 3,
      },
      typeSupplyOptions: [{value: 1, text: "Matéria-Prima"}, {value: 2, text: "Componente"}],
      //--------------------------------------------------------------------------------------
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()


    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await http.list(this.path + "/selectRelationList").then((response) => {

        this.rawMaterialList = response.rawMaterialList
        this.componentList = response.componentList

        this.rawMaterialOptions = []
        this.componentOptions = []

        for (let item of this.rawMaterialList) {

          const option = {
            value: item.rawMaterialId,
            text: item.name
          }

          this.rawMaterialOptions.push(option)

        }

        for (let item of this.componentList) {

          const option = {
            value: item.componentId,
            text: item.name
          }

          this.componentOptions.push(option)

        }


      }).catch(error => this.responseError(error))

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.productSupplyId)

    },

    mountedList() {


      // Manipulação da listagem após carregando
      //--------------------------------------
      let newItems = []

      for (let item of this.items) {

        if (item.typeSupply === 1) {
          item.typeSupply = "Matéria-Prima"
        } else {
          item.typeSupply = "Componente"
        }

        item.quantity = ui.convertNumber(item.quantity, item.decimalPrecision, "pt-br") + " " + item.unit

        newItems.push(item)

      }

      this.items = newItems
      //--------------------------------------

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    setMeasure(id) {

      if(id > 0 && id !== ""){

        if (this.form.typeSupply === 1) {

          const item = this.rawMaterialList.find(item => item.rawMaterialId === id)

          this.measure.unit = item.unit
          this.measure.decimalPrecision = item.decimalPrecision

        } else if (this.form.typeSupply === 2) {

          const item = this.componentList.find(item => item.componentId === id)

          this.measure.unit = item.unit
          this.measure.decimalPrecision = item.decimalPrecision

        }

      }else{

        //Valores padrões
        this.measure.unit = "Kg"
        this.measure.decimalPrecision = 3

      }

    },

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
